import menu from './menu'
import layout from './layout'
import home from './home'
import referrals from './referrals'
import resetPassword from './resetPassword'
import resume from './resume'
import consent from './consent'
import report from './report'
import profile from './profile'
import applications from './applications'
import offerLetter from './offerLetter'
import functions from './functions'
import interview from './interview'

export default {
  menu,
  layout,
  home,
  referrals,
  resume,
  resetPassword,
  consent,
  report,
  profile,
  applications,
  offerLetter,
  functions,
  interview
}
